import { CardModule } from 'primeng/card';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SignupComponent } from './signup/signup.component';
import { MessageService } from 'primeng/api';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { AccordionModule } from 'primeng/accordion';
import { EditorModule } from 'primeng/editor';
import { InputSwitchModule } from 'primeng/inputswitch';
import { MenuModule } from "primeng/menu";
import { MenubarModule } from "primeng/menubar";
import { MessageModule } from "primeng/message";
import { ButtonModule } from "primeng/button";
import { MessagesModule } from "primeng/messages";
import { TabMenuModule } from "primeng/tabmenu";
import { TooltipModule } from "primeng/tooltip";
import { StepsModule } from "primeng/steps";
import { PanelModule } from "primeng/panel";
import { DropdownModule } from "primeng/dropdown";
import { InputTextModule } from "primeng/inputtext";
import { TabViewModule } from "primeng/tabview";
import { ConfirmDialogModule } from "primeng/confirmdialog";
import { FileUploadModule } from "primeng/fileupload";
import { CalendarModule } from "primeng/calendar";
import { DialogModule } from "primeng/dialog";
import { RadioButtonModule } from "primeng/radiobutton";
import { CheckboxModule } from "primeng/checkbox";
import { ToolbarModule } from "primeng/toolbar";
import { ListboxModule } from "primeng/listbox";
import { ColorPickerModule } from "primeng/colorpicker";
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { DataViewModule } from 'primeng/dataview';
import { ToastModule } from 'primeng/toast';
import { AppServiceManager } from 'common/services/appServiceManager';
import { Configuration } from 'config/config';
import { WebcamModule } from 'ngx-webcam';
import { CameraComponent } from '../members/camera/camera.component';
import { ImageCropperModule } from 'ngx-image-cropper';
import { AddpackageBuilderComponent } from './addpackage-builder/addpackage-builder.component';
import { TableModule, TableService } from 'primeng/table';
import { NgxSpinnerModule } from 'ngx-spinner';
import { FeesManagementComponent } from './feesManagement/fees-management/fees-management.component';
import { ReceiptPrintComponent } from './receipt/receipt-print/receipt-print.component';
import { AddMultipleSignupComponent } from './signup/add-multiple-signup/add-multiple-signup.component';
import { AddSingleSignupComponent } from './signup/add-single-signup/add-single-signup.component';
import { FeeCollectComponent } from '../members/components/fee-collect/fee-collect.component';
import { FeesInvoiceComponent } from '../members/components/fees-invoice/fees-invoice.component';
import { AddFeeComponent } from '../members/components/add-fee/add-fee.component';
import { AddProfileImageComponent } from '../members/components/add-profile-image/add-profile-image.component';
import { EmailConfirmationModalComponent } from '../members/email-confirmation-modal/email-confirmation-modal.component';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { ExportDataComponent } from '../members/components/export-data/export-data.component';
import { AddLogoSizeImageComponent } from '../members/components/add-logo-size-image/add-logo-size-image.component';
import { SingleReceiptPrintComponent } from './receipt/single-receipt-print/single-receipt-print.component';
import { FbrReceiptBlockComponent } from './receipt/fbr-receipt-block/fbr-receipt-block.component';
import { SingleReceiptEmailComponent } from './receipt/single-receipt-email/single-receipt-email.component';
import { TrainingSessionAttdComponent } from 'app/members/components/training-session-attd/training-session-attd.component';
import { MultiSelectModule } from 'primeng/multiselect';
import { FeeCollectionSignupComponent } from 'app/members/components/feeCollection-signup/feeCollection-signup.component';
import { PhoneNumberInputComponent } from '../phoneNumber/phone-input.component';
import { ActionButtonComponent } from './components/action-button/action-button.component';
import { RouterModule } from '@angular/router';
import { ConfirmDialogComponent } from './components/confirm-dialog/confirm-dialog.component';




@NgModule({
  declarations: [
    SignupComponent,
    CameraComponent,
    AddpackageBuilderComponent,
    SingleReceiptPrintComponent,
    SingleReceiptEmailComponent,
    FbrReceiptBlockComponent,
    FeesManagementComponent,
    ReceiptPrintComponent,
    EmailConfirmationModalComponent,
    AddMultipleSignupComponent,
    AddSingleSignupComponent,
    FeeCollectComponent,
    AddProfileImageComponent,
    AddLogoSizeImageComponent,
    FeeCollectionSignupComponent,
    ExportDataComponent,
    FeesInvoiceComponent,
    AddFeeComponent,
    TrainingSessionAttdComponent,
    PhoneNumberInputComponent,
    ActionButtonComponent,
    ConfirmDialogComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    ReactiveFormsModule,
    FormsModule,
    MenuModule,
    MenubarModule,
    AccordionModule,
    DataViewModule,
    MessagesModule,
    MessageModule,
    ButtonModule,
    TabMenuModule,
    WebcamModule,
    ImageCropperModule,
    StepsModule,
    TooltipModule,
    TabViewModule,
    PanelModule,
    ConfirmDialogModule,
    NgxSpinnerModule,
    DialogModule,
    TableModule,
    ToastModule,
    DropdownModule,
    InputTextModule,
    CalendarModule,
    CheckboxModule,
    RadioButtonModule,
    FileUploadModule,
    ListboxModule,
    ColorPickerModule,
    CardModule,
    EditorModule,
    CKEditorModule,
    ProgressSpinnerModule,
    MultiSelectModule,
    InputSwitchModule,
  ],
  exports: [InputSwitchModule, SignupComponent, CameraComponent, SingleReceiptPrintComponent, SingleReceiptEmailComponent, FbrReceiptBlockComponent, PhoneNumberInputComponent, ActionButtonComponent, ConfirmDialogComponent, AddpackageBuilderComponent,AddProfileImageComponent,ExportDataComponent,EmailConfirmationModalComponent, CKEditorModule, AddLogoSizeImageComponent,AddFeeComponent,TrainingSessionAttdComponent],
  providers: [MessageService, AppServiceManager, Configuration,ExportDataComponent]
})
export class SharedModule { }
